module.exports = __webpack_public_path__ + "static/media/Club Royal Logo with tagline-01.011a849f.jpg";